// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $InternalParameterId = (tag, _1) => ({tag, _1});
const OriginIsSymbol = {reflectSymbol: () => "Origin"};
const FulfillmentMethodIsSymbol = {reflectSymbol: () => "FulfillmentMethod"};
const PaymentMethodIsSymbol = {reflectSymbol: () => "PaymentMethod"};
const IsDividedIsSymbol = {reflectSymbol: () => "IsDivided"};
const ScheduleIsSymbol = {reflectSymbol: () => "Schedule"};
const Origin = /* #__PURE__ */ $InternalParameterId("Origin");
const FulfillmentMethod = /* #__PURE__ */ $InternalParameterId("FulfillmentMethod");
const PaymentMethod = /* #__PURE__ */ $InternalParameterId("PaymentMethod");
const IsDivided = /* #__PURE__ */ $InternalParameterId("IsDivided");
const Schedule = value0 => $InternalParameterId("Schedule", value0);
const eqInternalParameterId = {
  eq: x => y => {
    if (x.tag === "Origin") { return y.tag === "Origin"; }
    if (x.tag === "FulfillmentMethod") { return y.tag === "FulfillmentMethod"; }
    if (x.tag === "PaymentMethod") { return y.tag === "PaymentMethod"; }
    if (x.tag === "IsDivided") { return y.tag === "IsDivided"; }
    if (x.tag === "Schedule") {
      if (y.tag === "Schedule") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordInternalParameterId = {
  compare: x => y => {
    if (x.tag === "Origin") {
      if (y.tag === "Origin") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Origin") { return Data$dOrdering.GT; }
    if (x.tag === "FulfillmentMethod") {
      if (y.tag === "FulfillmentMethod") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "FulfillmentMethod") { return Data$dOrdering.GT; }
    if (x.tag === "PaymentMethod") {
      if (y.tag === "PaymentMethod") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "PaymentMethod") { return Data$dOrdering.GT; }
    if (x.tag === "IsDivided") {
      if (y.tag === "IsDivided") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "IsDivided") { return Data$dOrdering.GT; }
    if (x.tag === "Schedule") {
      if (y.tag === "Schedule") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqInternalParameterId
};
const genericInternalParameterId = {
  to: x => {
    if (x.tag === "Inl") { return Origin; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return FulfillmentMethod; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return PaymentMethod; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return IsDivided; }
          if (x._1._1._1.tag === "Inr") { return $InternalParameterId("Schedule", x._1._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Origin") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "FulfillmentMethod") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "PaymentMethod") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "IsDivided") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Schedule") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))); }
    $runtime.fail();
  }
};
const showInternalParameterId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OriginIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FulfillmentMethodIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PaymentMethodIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(IsDividedIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})(ScheduleIsSymbol);
    return x => {
      const $5 = genericInternalParameterId.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeInternalParameterId = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OriginIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(FulfillmentMethodIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PaymentMethodIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(IsDividedIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct(ScheduleIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)
    }))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericInternalParameterId.to($0(x));
  })()
};
const ufromJSONKeyInternalParameterId = /* #__PURE__ */ (() => (
  {fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodeInternalParameterId.unsafeDecode)}
))();
const encodeInternalParameterId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericInternalParameterId)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(OriginIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(FulfillmentMethodIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentMethodIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(IsDividedIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(ScheduleIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeInternalParameterId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericInternalParameterId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OriginIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FulfillmentMethodIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentMethodIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(IsDividedIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ScheduleIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))))))
};
const asJSONKeyInternalParameterId = /* #__PURE__ */ (() => (
  {asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodeInternalParameterId.encode, decodeInternalParameterId.decode)}
))();
export {
  $InternalParameterId,
  FulfillmentMethod,
  FulfillmentMethodIsSymbol,
  IsDivided,
  IsDividedIsSymbol,
  Origin,
  OriginIsSymbol,
  PaymentMethod,
  PaymentMethodIsSymbol,
  Schedule,
  ScheduleIsSymbol,
  asJSONKeyInternalParameterId,
  decodeInternalParameterId,
  encodeInternalParameterId,
  eqInternalParameterId,
  genericInternalParameterId,
  ordInternalParameterId,
  showInternalParameterId,
  ufromJSONKeyInternalParameterId,
  unscrambleDecodeInternalParameterId
};
